<template>
  <b-col md="12" xl="6">
    <section class="reservation">
      <p class="reservation__title">I dati della tua prenotazione</p>
      <div class="reservation__wrap">
        <div class="reservation__check">
          <span class="reservation__date">Arrivo: <strong class="semibold">{{ reservation.arrival }}</strong></span>
          <span class="reservation__time">{{ reservation.checkin }}</span>
        </div>
        <div class="reservation__check">
          <span class="reservation__date">Partenza: <strong class="semibold">{{ reservation.departure }}</strong></span>
          <span class="reservation__time">{{ reservation.checkout }}</span>
        </div>
      </div>
      <p class="reservation__duration">
        <span>Durata del soggiorno: </span>
        <strong class="semibold">{{ reservation.nights }}</strong>
      </p>
      <div class="reservation__info">
        <span class="reservation__info-text semibold">1 camera</span>
        <span class="reservation__info-text semibold ml-1">per {{ reservation.occupancy }}</span>
      </div>
      <span class="text--sm d-block">
        Preferenza letto: <strong class="semibold">{{ reservation.bed }}</strong><br>
        La struttura non garantisce la disponibilità della preferenza letto.
      </span>
    </section>
  </b-col>
</template>

<script>
import { parse_date } from "@utilities/commons"
import { get_label_occupancy, get_total_nights } from '@liveeps/utilities'

export default {
  inheritAttrs: false,
  name: 'reservation',

  components: {
  },

  props: {
    solution: Object,
  },

  data() {
    return {
    }
  },

  computed: {

    // Genera la struttura dati della prenotazione
    reservation() {
      const { occupancy, dates, property } = this.solution,
            { checkin, checkout } = dates

      const get_date = (date) => {
        const parsed = parse_date(date)
        return `${parsed.day_number} ${parsed.month_string} ${parsed.year}`
      }

      return {
        arrival: get_date(checkin),
        departure: get_date(checkout),
        occupancy: this.get_label_occupancy(occupancy),
        nights: this.get_total_nights(checkin, checkout),
        bed: property.bed_type ? property.bed_type.description : ''
      }

    }
  },

  created() {
    this.get_label_occupancy = get_label_occupancy
    this.get_total_nights = get_total_nights
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .reservation {
    background-color: $selected;
    border-radius: $border-radius-lg * 2;
    padding: $grid-gutter-20;
    border: 1px solid $gray-300;
    margin-top: $grid-gutter-width;

    @include media-breakpoint-up(xl){
      margin-top: 0;
    }

    &__title {
      font-size: $font-size-lg;
      font-weight: $vb-font-weight-semibold;
      margin-bottom: $grid-gutter-width / 6;
    }

    &__wrap {
      display: flex;
      align-items: center;
    }

    &__check {
      span {
        display: block;
      }

      &:first-child {
        border-right: 1px solid $gray-300;
        margin-right: $grid-gutter-20;
        padding-right: $grid-gutter-20;
      }
    }

    &__duration {
      margin: $grid-gutter-20 0 $grid-gutter-width / 6;
    }

    &__info {
      display: flex;
      align-items: center;
    }
  }

</style>